import { render, staticRenderFns } from "./SettingsGenericUrlsPage.vue?vue&type=template&id=ddfd94c0"
import script from "./SettingsGenericUrlsPage.vue?vue&type=script&lang=ts"
export * from "./SettingsGenericUrlsPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsGenericUrlsPage.vue?vue&type=style&index=0&id=ddfd94c0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports